import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import { batchList } from "../../../api/Batch";
import { holidaysDetails, holidaysUpdate } from "../../../api/Holidays";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function HolidaysUpdate() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [batches, setBatches] = useState([]);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const getBatches = async () => {
    try {
      const response = await batchList();

      if (response?.data?.status === true) {
        setBatches(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to load batches.",
      );
    }
  };

  const getHolidaysDetails = async () => {
    setLoading(true);

    try {
      const response = await holidaysDetails(id);

      if (response?.data?.status === true) {
        const holiday = response?.data?.data || {};

        let batchIds = [];

        try {
          if (holiday?.batch_id) {
            const parsed = JSON.parse(holiday.batch_id);

            if (Array.isArray(parsed)) {
              batchIds = parsed.map((item) => String(item));
            }
          }
        } catch (error) {
          batchIds = [];
        }

        setData({
          ...holiday,
          batch_id_array: batchIds,
          description: holiday?.description || "",
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to load holiday details.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFromSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await holidaysUpdate(formData);

      if (response?.data?.status === true) {
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.message || "Holiday updated successfully.",
        );

        navigate("/holidays");
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ??
          err?.message ??
          "Unable to update holiday.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleBatchChange = (batchId) => {
    const id = String(batchId);

    setData((prev) => {
      const current = prev?.batch_id_array || [];

      if (current.includes(id)) {
        return {
          ...prev,
          batch_id_array: current.filter((item) => item !== id),
        };
      }

      return {
        ...prev,
        batch_id_array: [...current, id],
      };
    });
  };

  useEffect(() => {
    if (id) {
      getBatches();
      getHolidaysDetails();
    }
  }, [id]);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    <div className="card">
                      {/* HEADER */}
                      <div className="card-header">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div>
                            <h4 className="text-primary mb-1">
                              <i className="ri-calendar-event-line me-2" />
                              Update Holiday
                            </h4>

                            <small className="text-muted">
                              Update holiday information and applicability
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-label-secondary"
                            onClick={() => navigate("/holidays")}
                          >
                            <i className="ri-arrow-left-line me-1" />
                            Back
                          </button>
                        </div>
                      </div>

                      <div className="card-body">
                        {!data?.id && !loading ? (
                          <div className="text-center py-5">
                            <div
                              className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle bg-label-warning"
                              style={{
                                width: 80,
                                height: 80,
                              }}
                            >
                              <i
                                className="ri-calendar-close-line text-warning"
                                style={{ fontSize: 40 }}
                              />
                            </div>

                            <h5>Holiday Not Found</h5>

                            <p className="text-muted">
                              The requested holiday could not be found.
                            </p>

                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => navigate("/holidays")}
                            >
                              <i className="ri-arrow-left-line me-1" />
                              Back to Holidays
                            </button>
                          </div>
                        ) : (
                          <form onSubmit={handleFromSubmit}>
                            <input
                              type="hidden"
                              name="id"
                              value={data?.id || ""}
                            />

                            <div className="row g-3">
                              {/* TITLE */}
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control input-capitalize"
                                    name="title"
                                    id="title"
                                    placeholder="Holiday Title"
                                    required
                                    value={data?.title || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        title: e.target.value,
                                      })
                                    }
                                  />

                                  <label htmlFor="title">Holiday Title</label>
                                </div>
                              </div>

                              {/* DATE */}
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="date"
                                    id="date"
                                    required
                                    value={data?.date || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        date: e.target.value,
                                      })
                                    }
                                  />

                                  <label htmlFor="date">Holiday Date</label>
                                </div>
                              </div>

                              {/* TYPE */}
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="type"
                                    id="type"
                                    className="form-select"
                                    required
                                    value={data?.leave_day_type || "full"}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        leave_day_type: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="full">Full Day</option>

                                    <option value="half">Half Day</option>
                                  </select>

                                  <label htmlFor="type">Holiday Type</label>
                                </div>
                              </div>

                              {/* APPLICABLE */}
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="applicable"
                                    id="applicable"
                                    className="form-select"
                                    required
                                    value={data?.applicable || "all"}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        applicable: e.target.value,
                                        batch_id_array:
                                          e.target.value === "batch"
                                            ? data?.batch_id_array || []
                                            : [],
                                      })
                                    }
                                  >
                                    <option value="all">All</option>

                                    <option value="batch">Batch</option>

                                    <option value="staff">Staff</option>
                                  </select>

                                  <label htmlFor="applicable">
                                    Applicable To
                                  </label>
                                </div>
                              </div>

                              {/* DESCRIPTION */}
                              <div className="col-12">
                                <div className="form-floating form-floating-outline">
                                  <textarea
                                    name="description"
                                    id="description"
                                    className="form-control"
                                    placeholder="Description"
                                    style={{
                                      minHeight: 110,
                                    }}
                                    value={data?.description || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        description: e.target.value,
                                      })
                                    }
                                  />

                                  <label htmlFor="description">
                                    Description
                                  </label>
                                </div>
                              </div>

                              {/* BATCH SELECTION */}
                              {data?.applicable === "batch" && (
                                <div className="col-12">
                                  <div className="border rounded p-3">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                      <div>
                                        <h6 className="mb-1">
                                          <i className="ri-group-line text-primary me-2" />
                                          Select Batches
                                        </h6>

                                        <small className="text-muted">
                                          Select the batches for which this
                                          holiday applies.
                                        </small>
                                      </div>

                                      <span className="badge bg-label-primary">
                                        {data?.batch_id_array?.length || 0}{" "}
                                        Selected
                                      </span>
                                    </div>

                                    {batches?.length > 0 ? (
                                      <div className="row g-2">
                                        {batches.map((batch, i) => {
                                          const checked =
                                            data?.batch_id_array?.includes(
                                              String(batch?.id),
                                            );

                                          return (
                                            <div
                                              className="col-md-3 col-lg-2"
                                              key={batch?.id || i}
                                            >
                                              <div
                                                className={`border rounded p-2 ${
                                                  checked
                                                    ? "border-primary bg-label-primary"
                                                    : ""
                                                }`}
                                              >
                                                <div className="form-check">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value={batch?.id}
                                                    id={`batch_${batch?.id}`}
                                                    name="batch_id[]"
                                                    checked={checked}
                                                    onChange={() =>
                                                      handleBatchChange(
                                                        batch?.id,
                                                      )
                                                    }
                                                  />

                                                  <label
                                                    className="form-check-label"
                                                    htmlFor={`batch_${batch?.id}`}
                                                  >
                                                    {batch?.title}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <div className="alert alert-warning mb-0">
                                        <i className="ri-information-line me-1" />
                                        No batches found.
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* CURRENT STATUS */}
                              <div className="col-md-6">
                                <div className="border rounded p-3">
                                  <div className="d-flex align-items-center">
                                    <div className="avatar avatar-sm me-3">
                                      <span className="avatar-initial rounded bg-label-info">
                                        <i className="ri-information-line" />
                                      </span>
                                    </div>

                                    <div>
                                      <small className="text-muted">
                                        Current Status
                                      </small>

                                      <div className="fw-semibold">
                                        {String(data?.status) === "1"
                                          ? "Approved"
                                          : String(data?.status) === "2"
                                            ? "Cancelled"
                                            : "Pending"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* MESSAGE STATUS */}
                              <div className="col-md-6">
                                <div className="border rounded p-3">
                                  <div className="d-flex align-items-center">
                                    <div className="avatar avatar-sm me-3">
                                      <span className="avatar-initial rounded bg-label-success">
                                        <i className="ri-mail-line" />
                                      </span>
                                    </div>

                                    <div>
                                      <small className="text-muted">
                                        Message Status
                                      </small>

                                      <div className="fw-semibold">
                                        {String(data?.message_status) ===
                                        "1" ? (
                                          <span className="text-success">
                                            <i className="ri-checkbox-circle-line me-1" />
                                            Sent
                                          </span>
                                        ) : (
                                          <span className="text-muted">
                                            <i className="ri-mail-close-line me-1" />
                                            Not Sent
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* INFO */}
                              <div className="col-12">
                                <div className="alert alert-primary mb-0">
                                  <i className="ri-information-line me-2" />
                                  Updating this holiday will modify the selected
                                  holiday record. For creating holidays across
                                  multiple dates, use the{" "}
                                  <strong>Add Holiday</strong> page and select{" "}
                                  <strong>Date Range</strong>.
                                </div>
                              </div>

                              {/* BUTTONS */}
                              <div className="col-12 text-end">
                                <button
                                  type="button"
                                  className="btn btn-label-secondary me-2"
                                  onClick={() => navigate("/holidays")}
                                >
                                  <i className="ri-close-line me-1" />
                                  Cancel
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  disabled={loading}
                                >
                                  <i className="ri-save-line me-1" />
                                  Update Holiday
                                </button>
                              </div>
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
